import React from "react";
import Filters from "../components/Filters/LogFilters";
import LogFilters from "../components/Filters/LogFilters";
import { LogProvider } from "../contexts/LogContext";
import LogsTable from "../components/tables/bvn_logs/LogsTable";

const BvnLogs = () => {
  return (
    <LogProvider>
      <section>
        <LogFilters />
      </section>
      <LogsTable />
    </LogProvider>
  );
};

export default BvnLogs;
